import React, { useState } from 'react';
import { Menu } from 'antd';
import OverallEffect from './OverallEffect/indexs';
import TrafficBuckets from './TrafficBuckets';
import RelatedIndicator from './RelatedIndicator';
import EffectIndicator from './EffectIndicator';
import './index.less';
function getIndexDefault(dataEffectValue) {
    if (dataEffectValue.showKeyIndexes) {
        return 'keyIndexs';
    }
    else if (dataEffectValue.showRelatedIndexes) {
        return 'relatedIndexs';
    }
    else if (dataEffectValue.showRecommendIndexes) {
        return 'recommendIndexs';
    }
    else {
        return '';
    }
}
export default function DataEffect(props) {
    const { title, className, style = {}, buckets, children, dataEffectValue } = props;
    const [currentKey, setCurrentKey] = useState(getIndexDefault(dataEffectValue));
    const changeMenu = (item) => {
        setCurrentKey(item.key);
    };
    return (<div id="data-effect" className="data-effect" style={style}>
      <header>{title}</header>
      
      <Menu className="data-effect-menu" mode="horizontal" onClick={(item) => { changeMenu(item); }} selectedKeys={[currentKey]}>
        {dataEffectValue.showKeyIndexes && <Menu.Item key="keyIndexs">关键指标</Menu.Item>}
        {dataEffectValue.showRelatedIndexes && <Menu.Item key="relatedIndexs">关联指标</Menu.Item>}
        {dataEffectValue.showRecommendIndexes && <Menu.Item key="recommendIndexs">推荐指标</Menu.Item>}
      </Menu>
      {currentKey === 'keyIndexs' && dataEffectValue.showKeyIndexes ? <div className="block-container">
          <OverallEffect dataEffectValue={dataEffectValue}/>
          <TrafficBuckets dataEffectValue={dataEffectValue}/>
      </div> : null}
      {currentKey === 'relatedIndexs' && dataEffectValue.showRelatedIndexes ? <div className="block-container">
        <RelatedIndicator dataEffectValue={dataEffectValue}/>
      </div> : null}
      {currentKey === 'recommendIndexs' && dataEffectValue.showRecommendIndexes ? <div className="block-container">
        <EffectIndicator dataEffectValue={dataEffectValue}/>
      </div> : null}
      <div className="data-effect-wrapper">{children}</div>
    </div>);
}
